export default "__VITE_ASSET__BUXqNRfI__"